
<template lang="html">
  	<div class="activityContainer">
    	<div class="mui-content">
			<div id="sliderInfo" class="mui-slider">
				<div id="sliderSegmentedControl" class="mui-slider-indicator mui-segmented-control mui-segmented-control-inverted mui-scroll-wrapper mui-rel">
					<div class="mui-scroll ">
						<a  v-for="(item,index) in tabArr" class=" mui-control-item" v-bind:href="'#item'+parseInt(index)+'mobile'" v-bind:class="[index == 0? 'mui-active' : '' ]">
							{{item}}
						</a>
					</div>
				</div>
				<div class="mui-slider-group">
					
					<div v-for="(item,index) in tabArr" :id="'item'+parseInt(index)+'mobile'" class="mui-slider-item mui-control-content" v-bind:class="[index == 0? 'mui-active' : '' ]">
						<div class="mui-scroll" v-show="index > 0">
							<div class="mui-loading">
								<div class="mui-spinner">
								</div>
							</div>
						</div>
						<tabList :activityArr="activityAllArr[index]" :idIndex='index' :activityAllArr="activityAllArr" v-show="index == 0"></tabList>
						<router-link to="/activityList">
							<div class="moreBtn" v-bind:class="[index > 0? 'none' : '' ]">查看全部活动</div>
						</router-link>
					</div>

				</div>
			</div>
		</div>
    </div>
</template>
<script>
	//组件
	import tabList from '../activityComponents/tabList.vue'
	import Server from '../../server/server.js'
	import $ from 'jquery' 
	import {commonPicUrl} from '../../common/url.js'
	export default {
	  	name: 'activityContainer',
	  	data(){
		  	return{
		  		imgSrc:commonPicUrl,
		  	}
	  	},
	  	props:['tabArr','activityAllArr'],
	  	components:{
	  		tabList,
	  	}, 
	  	methods:{
	  		activityTab(){
	  			console.log(1);
				document.getElementById('sliderInfo').addEventListener('slide', function(e) {
					let id = 'item'+e.detail.slideNumber+'mobile';
					let item = document.getElementById(id);
					if (item.querySelector('.mui-loading')) {
						setTimeout(function() {
							item.querySelector('.mui-scroll').style.cssText="display: none;";
							item.querySelector('.activityBox').style.cssText="display: block;";
							item.querySelector('.moreBtn').style.cssText="display: block;";
						}, 500);
					}
				});
	  		},
	  	},
	  	mounted(){
	  		this.mui.init({
				swipeBack:false //启用右滑关闭功能
			});	
		    this.$nextTick(function () {
		    	this.mui.init()
		    	//滑动
		    	this.activityTab();
			});
	  	},
	  	updated: function() {
	  		this.mui.init();
            var sliderMuiObj = this.mui("#sliderInfo");
            sliderMuiObj.slider({
                interval: 5000000
            });
            this.mui('.mui-scroll-wrapper').scroll({
				deceleration: 0.0005 //flick 减速系数，系数越大，滚动速度越慢，滚动距离越小，默认值0.0006
			});
        },

	}
</script>
<style lang="less" scoped>
	.activityContainer{
		width:100%;
		padding:0 40px;
		margin-bottom:40px;
		.mui-slider-indicator{
			white-space: nowrap;
		    overflow-x:scroll;
		    overflow-y:hidden;
		}
		.mui-slider-indicator a{
			font-size:28px;
			color:#333333;
			letter-spacing:0;
			line-height:56px;
			border-bottom:none;
			display:inline-block;
			padding:0 20px;
			width:auto!important;
		}
		.mui-slider .mui-segmented-control.mui-segmented-control-inverted~.mui-slider-group .mui-slider-item{
			border:none!important;
		}
		.mui-control-item.mui-active{
			color:#ad8f5a!important;
			border-bottom:3px solid #ad8f5a!important;
		}
		.mui-rel{
			height:60px!important;
		}
		.mui-loading{
			margin-top:50px;
		}
		.mui-spinner{
			width:50px!important;
			height:50px!important;
		}
		.loading{
			width:100%;
			height:40px;
			text-align:center;
			line-height:40px;
			img{
				vertical-align:middle;
				width:40px;
			}
			span{
				padding-left:10px;
				font-size:26px;
				color:#666666;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/activity/activity.vue